import axios from 'axios'
import {API_URL} from './baseurl'

import { Message } from 'element-ui';
const ax = axios.create({
    // 公用前缀
    baseURL: API_URL,
    timeout: 20000,
    // headers: { 'X-Custom-Header': 'foobar' }
});

// 添加请求拦截器
ax.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    //判断是不是登录页，如果不是登录页，就判断有没有userInfo，有就把token带上没有
    if(config.url!='/userlogin'){
        if(userInfo){
            config.headers.authorization = userInfo.token
        }
    }
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
ax.interceptors.response.use(function (response) {
    
    // 对响应数据做点什么
    return response
}, function (error) {
    // 对响应错误做点什么
    switch (error.response.status) {
        case 400:
          error.message = `错误请求`;
          Message.warning('错误请求')
          break;
        case 401:
          error.message = `未授权，请重新登录`;
          Message.warning('未授权，请重新登录')
          break;
        case 403:
          error.message = `拒绝访问`;
          Message.warning('拒绝访问')
          break;
        case 404:
          error.message = `请求错误,未找到该资源`;
          Message.warning('请求错误,未找到该资源')
          break;
        case 405:
          error.message = `请求方法未允许`;
          Message.warning('请求方法未允许')
          break;
        case 408:
          error.message = `请求超时`;
          Message.warning('请求超时')
          break;
        case 500:
          error.message = `服务器端出错`;
          Message.warning('服务器端出错')
          break;
        case 501:
          error.message = `网络未实现`;
          Message.warning('网络未实现')
          break;
        case 502:
          error.message = `网络错误`;
          Message.warning('网络错误')
          break;
        case 503:
          error.message = `服务不可用`;
          Message.warning('服务不可用')
          break;
        case 504:
          error.message = `网络超时`;
          Message.warning('网络超时')
          break;
        case 505:
          error.message = `http版本不支持该请求`;
          Message.warning('http版本不支持该请求')
          break;
        default:
          error.message = `未知错误${error.response.status}`;
    }
    return Promise.reject(error);
});

export default ax


// WEBPACK FOOTER //
// ./src/axios.js